import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import { CheckboxField } from "@ps-design-system/components/Checkbox";
import { Form } from "@ps-design-system/components/Form";

import {
  TAX_DETAILS_FORM_ID,
  TAX_DETAILS_FORM_RETURN_PATH,
} from "../TaxDetailsFormSection.consts";
import { TAX_DETAILS_FORM_MESSAGES } from "../TaxDetailsFormSection.messages";

import { TaxDetailsFormAddress } from "./TaxDetailsFormAddress";
import { useTaxDetailsForm } from "./TaxDetailsFormContext";
import { TaxDetailsFormFields } from "./TaxDetailsFormFields";
import { TaxDetailsFormHeader } from "./TaxDetailsFormHeader";

/** The tax registration form: everything between the heading and the buttons. */
const TaxDetailsForm = () => {
  const { form, hasScopedTax, isEdit, submit } = useTaxDetailsForm();

  const submitLabel = isEdit
    ? TAX_DETAILS_FORM_MESSAGES.updateSubmit
    : TAX_DETAILS_FORM_MESSAGES.addSubmit;

  const { isSubmitting } = form.formState;

  return (
    <div className="tw-flex tw-flex-col tw-gap-40 [&_label]:tw-normal-case">
      <TaxDetailsFormHeader />

      <Form
        {...form}
        fullWidth={true}
        id={TAX_DETAILS_FORM_ID}
        onSubmit={form.handleSubmit(submit)}
        spacing={32}
      >
        <TaxDetailsFormFields />

        <TaxDetailsFormAddress />

        <CheckboxField
          description={
            <FormattedMessage
              {...TAX_DETAILS_FORM_MESSAGES.confirmationLabel}
            />
          }
          name="isConfirmed"
          testId="tax-details-confirmation"
        />

        <div className="tw-flex tw-flex-col tw-gap-16">
          <Button
            appearance="purple"
            disabled={isSubmitting || !hasScopedTax}
            fullWidth={true}
            showSpinner={isSubmitting}
            testId="tax-details-submit"
            type="submit"
          >
            <FormattedMessage {...submitLabel} />
          </Button>

          <Button
            appearance="black"
            fullWidth={true}
            href={TAX_DETAILS_FORM_RETURN_PATH}
            testId="tax-details-cancel"
            variant="text-only"
          >
            <FormattedMessage {...TAX_DETAILS_FORM_MESSAGES.cancel} />
          </Button>
        </div>
      </Form>
    </div>
  );
};

export { TaxDetailsForm };
